InspecDistAddEditDialogCtrl.$inject = ['$log', '$scope'];
export default function InspecDistAddEditDialogCtrl($log, $scope) {

    $scope.nombreOpciones = Sigo.config['proyecto'] === "ocoval" ? "nombres.barrio" : "nombres.distrito";

    if ($scope.model.distritos.length > 0)
        $scope.model.distrito = $scope.model.distritos[0];

    if ($scope.model.inspectores.length > 0)
        $scope.model.inspector_id = $scope.model.inspectores[0].id;
}